import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Landing from "../Landing";
import GlobalHome from "../GloablHome/GlobalHome";
import VendorOnboardConfirmation from "../VendorOnboarding/Views/VendorOnboardConfirmation";
import Dashboard from "../Dashboard/Dashboard";
import SignIn from "../Signin";
import Notifications from "../Notifications/Notifications";
import Resources from "../Resources/Resources";
import PublishNotification from "../PublishNotifications/PublishNotification";
import PrivateRoutes from "./PrivateRoutes";
import Welcome from "..//VendorOnboarding/Views/Welcome";
import OnboardingContainer from "../VendorOnboarding/OnboardingContainer";
import Header from "../Header/Header";
import Cookies from "js-cookie";
import ShippingContainer from "../ShippingLocation/ShippingContainer";
import RoutingRequest from "../ShippingLocation/RoutingRequest";
import SellerReports from "../SellerReports/SellerReports";
import ManageUser from "../UserManagement/ManageUser/manageuser";
import DocumentLibraryUpdatesList from "../DocumentLibrary/DocumentLibraryUpdatesList";

const Routes = (props) => {
  return (
    <div>
      {Cookies.get("userName") && <Header />}
      {localStorage.getItem("roles") &&
      localStorage.getItem("roles") !== '""' &&
      localStorage.getItem("roles").includes("roleName") ? (
        <Switch>
          <PrivateRoutes exact path="/" component={Landing} />
          <PrivateRoutes
            exact
            path="/boarding/merchant"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/merchant/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/merchant/merchantbrand/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/merchant/dvnbrand/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/ops/:step/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/vendor"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/vendor/:type"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/vendor/:type/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/vendor/dvnbrand/:type/:profileId"
            component={OnboardingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/shipping"
            component={ShippingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/shipping/:type"
            component={ShippingContainer}
          />
          <PrivateRoutes
            exact
            path="/boarding/routing"
            component={ShippingContainer}
          />
          <PrivateRoutes
            exact
            path="/sellerreports/:type"
            component={SellerReports}
          />
          <PrivateRoutes
            exact
            path="/document-library-recent-updates"
            component={DocumentLibraryUpdatesList}
          />
          <PrivateRoutes exact path="/dashboard/:year" component={Dashboard} />
          <PrivateRoutes exact path="/mvp" component={GlobalHome} />
          <PrivateRoutes exact path="/manageusers" component={ManageUser} />
          <PrivateRoutes
            exact
            path="/globalNotifications"
            component={Notifications}
          />
          <PrivateRoutes
            exact
            path="/notifications/publish"
            component={PublishNotification}
          />
          <PrivateRoutes exact path="/resource" component={Resources} />
          <PrivateRoutes exact path="/signin" component={SignIn} />
          <PrivateRoutes
            exact
            path="/vob-confirmation"
            component={VendorOnboardConfirmation}
          />
          <PrivateRoutes exact path="/welcome" component={Welcome} />
          <PrivateRoutes path="/*" component="" />
        </Switch>
      ) : (
        <Switch>
          <PrivateRoutes path="/" component={Landing} />
        </Switch>
      )}
    </div>
  );
};

export default Routes;
